import React, { useState, useReducer, useEffect, useRef } from 'react';
// import { Link } from "react-router-dom";
import { Link, useParams } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import breakimage from '../../../../images/auth/Front-break.jpg';
import $ from 'jquery';
import { Modal, Button, Row, Col, Tab, Nav, Badge, Tooltip, OverlayTrigger } from "react-bootstrap";
// import { Modal, Button, Badge, Row, Col } from "react-bootstrap";
import LightGallery from 'lightgallery/react';
// import styles
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail'; 
import lgZoom from 'lightgallery/plugins/zoom';
// import { Button } from "react-bootstrap";
import rice_img from '../../../../images/raw_material/else.jpg';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const ViewVendors = () => {

      
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sno = queryParams.get('data');
  const navigate = useNavigate();
  
  const onInit = () => {
      //   console.log('lightGallery has been initialized');
  };
  const [key, setKey] = useState('basic_info');
  const [isVisible, setIsVisible] = useState({
      weekly: true,
      monthly: true,
      yearly: false, 
  });  
  const toggleDiv = (section) => {
      setIsVisible((prev) => ({
          ...prev,
          [section]: !prev[section], // Toggle the visibility of the clicked section
      }));
  };
  const [selectedOption, setSelectedOption] = useState(null);
  const [hovered, setHovered] = useState(false);

  const containerStyle = {
      position: 'relative',
      width: '100px',
      height: '110px',
  };

  const orderBlog = [
      { id: 1, image: breakimage, number: 1 }, 
  ];

  const imageStyle = {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
      transform: hovered ? 'scale(1.05)' : 'scale(1)',
      boxShadow: hovered ? '0 6px 16px rgba(0, 0, 0, 0.25)' : 'none',

  };

  const iconStyle = {
      display: hovered ? 'inline-block' : 'none',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'rgb(180, 228, 126)',
      borderRadius: '50%',
      padding: '8px',
      transition: 'opacity 0.3s ease',
  };



  const reducer = (previousState, updatedState) => ({
      ...previousState,
      ...updatedState,
  });
  const [state, setState] = useReducer(reducer, { orderBlog: orderBlog });

  
  // const { sno } = useParams(); // get vendor id from route param

  const [vendor, setVendor] = useState(null);
  const baseURL = process.env.REACT_APP_API_BASE_URL;

//     useEffect(() => {
//     if (sno) {
//         fetch(`${baseURL}/managevendor/${sno}`)
//             .then(res => res.json())
//             .then(data => {
//                 if (data.vendor) {
//                     // Ensure attachments is always an array
//                     let vendorData = { ...data.vendor };
//                     try {
//                         vendorData.attachments = vendorData.attachments 
//                             ? JSON.parse(vendorData.attachments) 
//                             : [];
//                     } catch (e) {
//                         vendorData.attachments = [];
//                     }

//                     setVendor(vendorData);
//                 } else {
//                     setVendor(null);
//                 }
//             })
//             .catch(err => {
//                 console.error("Failed to fetch vendor:", err);
//                 setVendor(null);
//             });
//     }
// }, [sno]);

  useEffect(() => {
  if (sno) {
      fetch(`${baseURL}/managevendor/${sno}`)
          .then(res => res.json())
          .then(data => {
              if (data.vendor) {
                  // Ensure attachments is always an array
                  let vendorData = { ...data.vendor };
                  try {
                      vendorData.attachments = vendorData.attachments 
                          ? JSON.parse(vendorData.attachments) 
                          : [];
                  } catch (e) {
                      vendorData.attachments = [];
                  }

                  setVendor(vendorData);
              } else {
                  setVendor(null);
              }
          })
          .catch(err => {
              console.error("Failed to fetch vendor:", err);
              setVendor(null);
          });
  }
  }, [sno]);



  useEffect(() => {
      const tables = document.querySelectorAll('.subscription_table');
      tables.forEach((table) => {
          if (!$.fn.dataTable.isDataTable(table)) {
              $(table).DataTable({
                  "responsive": true,
                  "ordering": false,
                  "language": {
                      "lengthMenu": "Show _MENU_",
                  },
                  "dom":
                      "<'row'" +
                      "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                      "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                      ">" +
                      "<'table-responsive'tr>" +
                      "<'row'" +
                      "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                      "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                      ">"
              });
          }
      });
  }, []);
  const [file, setFile] = React.useState(null)


  const [selectedPayment, setSelectedPayment] = useState(null);

  const handleViewHistory = (payment) => {
  setSelectedPayment(payment);
  };



    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0 flex-wrap">
                <div className='mb-2'>
                    <div className="mb-0 px-0">
                         <h4 style={{ color: '#025d3a' }}>View Vendor</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item">Purchase Management</li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active"><Link to='/manage-items'>Manage Vendors</Link></li>
                    </ol>
                </div>
                  {vendor && (
                <div className='mb-2'>
                    <div className='fs-5 font-w500 text-black'>
                        <span className='me-2'><i className='fas fa-user fs-4 text-info'></i></span>
                        <span>{vendor.vendor_businessname}</span>
                    </div>
                    <div className='d-block'>
                        <label className='fs-7 font-w500 text-black'>
                            <span className='me-2'><i className='fas fa-phone fs-4 text-info'></i></span>
                            <span>{vendor.vendor_mobileno}</span>
                        </label>
                    </div>
                </div>
                  )}
            </div>
            <Col xl={12} className='mb-3'>
                <div className="custom-tab-1">
                    <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                        <Nav as="ul" className="nav-tabs">
                            <Nav.Item as="li" >
                                <Nav.Link eventKey="basic_info">
                                    <i className="fa-regular fa-user me-2" />
                                    <span className="ms-2 fs-6">
                                        Basic Information
                                    </span>

                                </Nav.Link>
                            </Nav.Item>
                            
                             <Nav.Item as="li" >
                                <Nav.Link eventKey="raw_material">
                                    <svg viewBox="0 0 1024 1024" class="icon" width="20px" height="20px" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#025d3a"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M960.1 258.4H245.8l-36.1-169H63.9v44h110.2l26.7 125 100.3 469.9 530 0.4v-44l-494.4-0.3-22.6-105.9H832l128.1-320.1z m-65 44L855.6 401H276.3l-21.1-98.6h639.9zM304.8 534.5L279.7 417h569.5l-47 117.5H304.8z" fill="#025d3a"></path><path d="M375.6 810.6c28.7 0 52 23.3 52 52s-23.3 52-52 52-52-23.3-52-52 23.3-52 52-52m0-20c-39.7 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.3-72-72-72zM732 810.6c28.7 0 52 23.3 52 52s-23.3 52-52 52-52-23.3-52-52 23.3-52 52-52m0-20c-39.7 0-72 32.2-72 72s32.2 72 72 72c39.7 0 72-32.2 72-72s-32.3-72-72-72zM447.5 302.4h16v232.1h-16zM652 302.4h16v232.1h-16z" fill="#025d3a"></path><path d="M276.3 401l3.4 16-3.4-16z" fill="#025d3a"></path></g></svg>
                                    {/* <i className="fa-regular fa-money-bill-1 " /> */}
                                    <span className="ms-2 fs-6">
                                        Raw Material
                                    </span> 
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link eventKey="purchase_his">
                                    <i className="fa-regular fa-money-bill-1 me-2" />
                                    <span className="ms-2 fs-6">
                                        Purchase History
                                    </span> 
                                </Nav.Link>
                            </Nav.Item>
                             <Nav.Item as="li" >
                                <Nav.Link eventKey="payment_his">
                                    <i className="fa-regular fa-money-bill-1 me-2" />
                                    <span className="ms-2 fs-6">
                                        Payment History
                                    </span> 
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <Tab.Content className="pt-4">
                            <Tab.Pane eventKey="basic_info">
                                <div className='row'>
                                    <div className='col-lg-4 pe-2'>
                                        {/* <div className='d-flex flex-column'> */}
                                        <div className='card px-3'>
                                            <div className="d-flex justify-content-center w-100 mt-3">
                                           {vendor && vendor.vendor_image && (
                                                <LightGallery
                                                    onInit={onInit}
                                                    speed={500}
                                                    plugins={[lgThumbnail, lgZoom]}
                                                >
                                                    <div data-src={vendor.vendor_image} className="d-flex rounded h-175px w-175px p-2">
                                                    <img src={vendor.vendor_image} style={{ width: "100%" }} alt={vendor.vendor_businessname || "Vendor"} className='cursor-pointer' />
                                                    </div>
                                                </LightGallery>
                                                )}


                                            </div>
                                            {vendor && (
                                                <>
                                                    <label className='text-green text-center fs-4 font-w600 mt-2 mb-2'>{vendor.vendor_businessname}</label>
                                                    <div className='fs-6 font-w500 text-black mb-1'>
                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover'><span>Email</span></Tooltip>} >
                                                        <span className='me-3'><i className='fa-regular fa-envelope fs-5'></i></span>
                                                    </OverlayTrigger>
                                                    <span>{vendor.vendor_emailid || '-'}</span>
                                                    </div>
                                                    <div className='fs-6 font-w500 text-black mb-1'>
                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover'><span>Mobile Number</span></Tooltip>} >
                                                        <span className='me-3'><i className='fa-solid fa-phone fs-5'></i></span>
                                                    </OverlayTrigger>
                                                    <span>{vendor.vendor_mobileno}</span>
                                                    </div>
                                                    <div className='fs-6 font-w500 text-black mb-1'>
                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover'><span>Address</span></Tooltip>} >
                                                        <span className='me-3'><i className='fa-solid fa-location-dot fs-5'></i></span>
                                                    </OverlayTrigger>
                                                    <span>{vendor.address || '-'}</span>
                                                    </div>

                                                    <label className='col-12 text-red fs-4 font-w600 mb-3 mt-3'>Contact Information</label>
                                                    <div className='row'>
                                                    <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                        <label className='text-gray-800 font-w500 fs-7'>Primary Contact Person</label>
                                                        <label className='text-black fs-6 font-w500'>{vendor.person_name || '-'}</label>
                                                    </div>
                                                    <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                        <label className='text-gray-800 font-w500 fs-7'>Primary Mobile Number</label>
                                                        <label className='text-black fs-6 font-w500'>{vendor.person_mobileno || '-'}</label>
                                                    </div>
                                                    <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                        <label className='text-gray-800 font-w500 fs-7'>Role/Position</label>
                                                        <label className='text-black fs-6 font-w500'>{vendor.person_role || '-'}</label>
                                                    </div>
                                                    <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                        <label className='text-gray-800 font-w500 fs-7'>Alter Contact person</label>
                                                        <label className='text-black fs-6 font-w500'>{vendor.person_alternative_no || '-'}</label>
                                                    </div>
                                                    <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                        <label className='text-gray-800 font-w500 fs-7'>Alter Mobile Number</label>
                                                        <label className='text-black fs-6 font-w500'>{vendor.alternative_no || '-'}</label>
                                                    </div>
                                                    </div>
                                                </>
                                                )}

                                            
                                        </div>
                                    </div>
                                   
                                    {vendor && (
                                        <div className='col-lg-8 pe-2'>
                                            <div className='card px-3'>
                                            <label className='col-12 text-red fs-4 font-w600 mb-3 mt-3'>Basic Information</label>
                                            <div className='row'>
                                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                <label className='text-gray-800 font-w500 fs-7'>Vendor Category</label>
                                                <label className='text-black fs-6 font-w500'>
                                                    {(vendor.vendor_category && vendor.vendor_category.vendorcategory_name) || '-'}
                                                </label>
                                                </div>
                                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                <label className='text-gray-800 font-w500 fs-7'>Business Type</label>
                                                <label className='text-black fs-6 font-w500'>
                                                    <Badge bg="info" className='text-white fs-8 py-0 px-1'>
                                                    {(vendor.business_type && vendor.business_type.businesstype_name) || '-'}
                                                    </Badge>
                                                </label>
                                                </div>
                                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                <label className='text-gray-800 font-w500 fs-7'>Settlement Type</label>
                                                <label className='text-black fs-6 font-w500'>
                                                    {/* {vendor.settlement_type || 'N/A'} {vendor.select_type || 'N/A'} */}  {vendor.settlement_type}{' '}
                                    {vendor.select_type === 0 ? 'Weeks' :
                                    vendor.select_type === 1 ? 'Months' :
                                    vendor.select_type === 2 ? 'Years' :
                                    ''}
                                                </label>
                                                </div>
                                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                <label className='text-gray-800 font-w500 fs-7'>Business Reg No</label>
                                                <label className='text-black fs-6 font-w500'>
                                                    {vendor.business_regno || '-'}
                                                </label>
                                                </div>
                                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                <label className='text-gray-800 font-w500 fs-7'>GST No</label>
                                                <label className='text-black fs-6 font-w500'>
                                                    {vendor.gstno || '-'}
                                                </label>
                                                </div>
                                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                <label className='text-gray-800 font-w500 fs-7'>Tax No</label>
                                                <label className='text-black fs-6 font-w500'>
                                                    {vendor.taxno || '-'}
                                                </label>
                                                </div>
                                            </div>

                                            <label className='col-12 text-red fs-4 font-w600 mb-3 mt-3'>Bank Information</label>
                                            <div className='row'>
                                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                <label className='text-gray-800 font-w500 fs-7'>Bank Name</label>
                                                <label className='text-black fs-6 font-w500'>
                                                    {vendor.bank_name || '-'}
                                                </label>
                                                </div>
                                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                <label className='text-gray-800 font-w500 fs-7'>Branch Name</label>
                                                <label className='text-black fs-6 font-w500'>
                                                    {vendor.branch_name || '-'}
                                                </label>
                                                </div>
                                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                <label className='text-gray-800 font-w500 fs-7'>Account Holder Name</label>
                                                <label className='text-black fs-6 font-w500'>
                                                    {vendor.account_holder_name || '-'}
                                                </label>
                                                </div>
                                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                <label className='text-gray-800 font-w500 fs-7'>Account No</label>
                                                <label className='text-black fs-6 font-w500'>
                                                    {vendor.account_no || '-'}
                                                </label>
                                                </div>
                                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                <label className='text-gray-800 font-w500 fs-7'>IFSC Code</label>
                                                <label className='text-black fs-6 font-w500'>
                                                    {vendor.ifsc_code || '-'}
                                                </label>
                                                </div>
                                            </div>

                                            <div className='row mt-3'>
                                                <div className='col-lg-12 col-md-12 pe-2'>
                                                <label className="text-gray-800 font-w600 fs-6">Description</label>
                                                <div className="text-black fs-7 px-1 py-3">
                                                    <p>
                                                    &emsp;&emsp; {vendor.description || '-'}
                                                    </p>
                                                </div>
                                                </div>
 

                                                <div className='col-lg-12 col-md-12 pe-2'>
                                                    <label className='text-gray-800 font-w600 fs-6'>Attachment</label>
                                                    <div className="avatar-upload d-flex flex-column align-items-start">
                                                        <div className="change position-relative">
                                                        <div className="d-flex flex-wrap align-items-center gap-2 px-2 py-2">
                                                       
                                                            {Array.isArray(vendor.attachments) && vendor.attachments.length > 0 ? (
                                                                vendor.attachments.map((attachment, index) => (
                                                                    <div key={index} style={containerStyle}>
                                                                        <img src={attachment.url} alt={`attachment-${index + 1}`} style={imageStyle} />
                                                                        <a href={attachment.url} download style={iconStyle}>
                                                                            <i className="fa-solid fa-download text-black fs-6"></i>
                                                                        </a>
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <p className="text-muted">No attachments available</p>
                                                            )}

                                                        </div>
                                                        </div>
                                                    </div>
                                                    </div>

                                            </div>
                                            </div>
                                        </div> 
                                        )}



                                </div>
                            </Tab.Pane>
                            
                            <Tab.Pane eventKey="raw_material">
                                <div className='row'>
                                    {vendor?.vendor_rawmaterials?.length > 0 ? (
                                        Object.entries(
                                            vendor.vendor_rawmaterials.reduce((acc, mat) => {
                                                const cat = mat.rawmaterial_category_name || 'Uncategorized';
                                                if (!acc[cat]) acc[cat] = [];
                                                acc[cat].push(mat);
                                                return acc;
                                            }, {})
                                        ).map(([category, materials], catIndex) => (
                                            <div key={catIndex} className="mb-4">
                                                <h5 className="text-dark fw-bold mb-3">{category}</h5>
                                                <div className="row">
                                                    {materials.map((material, index) => (
                                                        <div key={index} className='col-lg-3 mb-3 pe-1'>
                                                            <div className="border rounded px-1 py-1 d-flex align-items-center justify-content-start gap-3">
                                                                <LightGallery
                                                                    onInit={onInit}
                                                                    speed={500}
                                                                    plugins={[lgThumbnail, lgZoom]}
                                                                >
                                                                    <div data-src={material.image_url || rice_img} className='rounded px-1 py-0'>
                                                                        <img
                                                                            src={material.image_url || rice_img}
                                                                            alt={material.rawmaterial_name}
                                                                            className='cursor-pointer w-60px h-60px'
                                                                        />
                                                                    </div>
                                                                </LightGallery>
                                                                <div className="d-flex flex-column">
                                                                    <OverlayTrigger
                                                                        trigger="hover"
                                                                        placement="bottom"
                                                                        overlay={
                                                                            <Tooltip className='toltip-popover'>
                                                                                <span className='fs-8 text-white fw-semibold'>
                                                                                    {material.rawmaterial_name}
                                                                                </span>
                                                                            </Tooltip>
                                                                        }>
                                                                        <label className='text-primary font-w500 fs-6 text-truncate w-150px'>
                                                                            {material.rawmaterial_name}
                                                                        </label>
                                                                    </OverlayTrigger>
                                                                    <label className='text-black font-w400 fs-7'>
                                                                        {/* {material.rawmaterial_category_name} */}
                                                                        <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Min Stock</span></Tooltip>} >
                                                                            <Badge bg="warning" className='text-white fs-7 py-0 px-1'>Min - {material.minimum_stock_level} {material.rawmaterial_unit_name}</Badge>
                                                                        </OverlayTrigger>
                                                                        <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Max Stock</span></Tooltip>} >
                                                                            <Badge bg="danger" className='text-white fs-7 py-0 px-1'>Max - {material.maximum_stock_level} {material.rawmaterial_unit_name}</Badge>
                                                                        </OverlayTrigger>
                                                                        {/* {material.minimum_stock_level} {material.rawmaterial_unit_name} - {material.maximum_stock_level} {material.rawmaterial_unit_name} */}
                                                                    </label>
                                                                    <label className='text-dark font-w400 fs-8'>
                                                                        <i className="fa-solid fa-indian-rupee-sign me-2"></i>
                                                                        {material.base_cost}
                                                                        
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="text-muted text-center my-3">No raw materials available.</div>
                                    )}
                                </div>
                            </Tab.Pane>

                            <Tab.Pane eventKey="purchase_his">
                              <Row>
                                <Col xl={12}>
                                  <div className="table-container">
                                    {vendor?.purchase_history && vendor.purchase_history.length > 0 ? (
                                      <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                        <thead>
                                          <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                            <th className='min-w-100px text-start'>Date</th>
                                            <th className='min-w-100px'>Purchase ID</th>
                                            <th className='min-w-100px text-center'>Raw Material</th>
                                            <th className='min-w-100px'>Purchase Amount</th> 
                                            <th className='min-w-80px text-center'>Status</th>
                                          </tr>
                                        </thead>
                                        <tbody className="text-gray-600 fw-semibold fs-7">
                                          {vendor.purchase_history.map((purchase) => (
                                            <tr key={purchase.sno}>
                                              <td className='text-start'>
                                                <label className='text-black font-w400 fs-7'>{purchase.purchase_date}</label>
                                              </td>
                                              <td>
                                                <label className='text-black font-w400 fs-7'>{purchase.purchase_id}</label>
                                              </td>
                                              <td className='text-center'>
                                                <label className='text-black font-w400 fs-7'>
                                                  <Badge bg="info" className='text-white fs-8 py-0 px-1'>{purchase.no_of_rawmaterial}</Badge>
                                                </label>
                                              </td>
                                              <td align='right'>
                                                {purchase.total_amount ? (
                                                <Badge bg="success" className='text-white fs-7 py-0 px-1'>
                                                  <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                  <span>{purchase.total_amount}</span>
                                                </Badge>
                                                ) : (
                                                  <span className='text-black'>-</span>
                                                )}
                                              </td> 
                                              <td align='center'>
                                                <span className="text-center">
                                                  <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover'><span className='fs-8 text-white fw-semibold'>View</span></Tooltip>} >
                                                    <Link to={`/view-purchase?data=${purchase.sno}`}>
                                                      <Button variant="primary tp-btn-light px-2 py-1 me-1">
                                                        <span><i className="fa fa-eye fs-6 mt-1"></i></span>
                                                      </Button>
                                                    </Link>
                                                  </OverlayTrigger>
                                                </span>
                                              </td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    ) : (
                                      <div className="text-muted text-center my-3">No purchase history available here.</div>
                                    )}
                                  </div>
                                </Col>
                              </Row>
                            </Tab.Pane>

                            <Tab.Pane eventKey="payment_his">
                              <Row>
                                <Col xl={12}>
                                  <div className="table-container">
                                    {vendor?.vendor_payments && vendor.vendor_payments.length > 0 ? (
                                      <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                        <thead>
                                          <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                            <th className='min-w-100px'>Purchase ID</th> 
                                            <th className='min-w-100px text-start'>Purchased Date</th>
                                            <th className='min-w-100px'>Purchase Amount</th> 
                                            <th className='min-w-100px text-start'>Paid Date</th>
                                            <th className='min-w-100px'>Paid Amount</th> 
                                            <th className='min-w-100px'>Balance Amount</th> 
                                            <th className='min-w-100px'>Action</th>
                                          </tr>
                                        </thead>
                                        <tbody className="text-gray-600 fw-semibold fs-7">
                                          {vendor.vendor_payments.map((vp) => (
                                            <tr key={vp.vendorpayment_id}>
                                              <td>
                                                <label className='text-black font-w400 fs-7'>
                                                  {`managepurchase_${String(vp.purchase_id).padStart(4, '0')}`}
                                                </label>
                                              </td>
                                              <td className='text-start'>
                                                <label className='text-black font-w400 fs-7'>{vp.purchase_date}</label>
                                              </td>
                                              <td align='right'>
                                                <Badge bg="success" className='text-white fs-7 py-0 px-1'>
                                                  <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                  <span>{vp.purchase_amount}</span>
                                                </Badge>
                                              </td>
                                              <td className='text-start'>
                                                <label className='text-black font-w400 fs-7'>{vp.paid_date}</label>
                                              </td>
                                              <td align='right'>
                                                <Badge bg="info" className='text-white fs-7 py-0 px-1'>
                                                  <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                  <span>{vp.paid_amount}</span>
                                                </Badge>
                                              </td>
                                              <td align='right'>
                                                <Badge bg="warning" className='text-white fs-7 py-0 px-1'>
                                                  <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                  <span>
                                                    {Number(vp.purchase_amount) - Number(vp.paid_amount)}
                                                  </span>
                                                </Badge>
                                              </td>
                                              <td align='right'>
                                                {/* Action button to view payment history */}
                                                <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleViewHistory(vp)}>
                                                  <span><i className="fa fa-eye fs-6 mt-1"></i></span>
                                                </Button>
                                              </td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    ) : (
                                      <div className="text-muted text-center my-3">No payment history available here.</div>
                                    )}
                                  </div>
                                </Col>
                              </Row>
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </div>
            </Col >

            <Modal show={!!selectedPayment} onHide={() => setSelectedPayment(null)} size="xl">
              <div className="modal-content">
                {/* Header */}
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                  <h3 className="modal-title text-white">Payment History</h3>
                  <Button
                    variant=""
                    type="button"
                    className="close px-6 py-1"
                    onClick={() => setSelectedPayment(null)}
                  >
                    <span className="text-white">×</span>
                  </Button>
                </div>

                {/* Body */}
                <div className="modal-body">
                  {selectedPayment && (
                    <>
                      {/* Purchase Details */}
                      <div className="row mb-4">
                        <div className="col-lg-4 col-md-4 d-flex flex-column mb-3">
                          <label className="text-black text-start font-w600 fs-7">Purchase ID</label>
                          <div className="d-block">
                            <label className="text-success font-w600 fs-6 py-0">
                              {`managepurchase_${String(selectedPayment.purchase_id).padStart(4, '0')}`}
                            </label>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-4 d-flex flex-column mb-3">
                          <label className="text-black text-start font-w600 fs-7">Purchase Date</label>
                          <div className="d-block">
                            <label className="text-success font-w600 fs-6 py-0">
                              {selectedPayment.purchase_date}
                            </label>
                          </div>
                        </div>
                        {/* <div className="col-lg-4 col-md-4 d-flex flex-column mb-3">
                          <label className="text-black text-start font-w600 fs-7">Staff</label>
                          <div className="d-block">
                            <label className="text-success font-w600 fs-6 py-0">
                              {selectedPayment.staff_name || "-"}
                            </label>
                          </div>
                        </div> */}
                        <div className="col-lg-4 col-md-4 d-flex flex-column mb-3">
                          <label className="text-black text-start font-w600 fs-7">Purchase Amount</label>
                          <div className="d-block">
                            <label className="text-success font-w600 fs-6 py-0">
                              <i className="fa-solid fa-indian-rupee-sign me-1"></i>
                              {selectedPayment.purchase_amount}
                            </label>
                          </div>
                        </div>
                      </div>

                      {/* Vendor & Amount */}
                      {/* <div className="row mb-4"> */}
                        {/* <div className="col-lg-4 col-md-4 d-flex flex-column mb-3">
                          <label className="text-black text-start font-w600 fs-7">Vendor</label>
                          <div className="d-block">
                            <label className="text-success font-w600 fs-6 py-0">
                              {selectedPayment.vendor_name}
                            </label>
                          </div>
                        </div> */}
                        {/* <div className="col-lg-4 col-md-4 d-flex flex-column mb-3">
                          <label className="text-black text-start font-w600 fs-7">Purchase Amount</label>
                          <div className="d-block">
                            <label className="text-success font-w600 fs-6 py-0">
                              <i className="fa-solid fa-indian-rupee-sign me-1"></i>
                              {selectedPayment.purchase_amount}
                            </label>
                          </div>
                        </div>
                      </div> */}
                    </>
                  )}

                  {/* Payment History Table */}
                  {/* <h6 className="fw-bold text-primary mb-3">Payment History</h6> */}
                  {selectedPayment?.payment_history?.length > 0 ? (
                    <div className="table-container">
                      <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2">
                        <thead>
                          <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                            <th className="min-w-100px text-white">Payment Date</th>
                            <th className="min-w-100px text-white">Payment Amount</th>
                            <th className="min-w-100px text-white">Balance Amount</th>
                            <th className="min-w-100px text-white">Payment Mode</th>
                            <th className="min-w-100px text-white">Transaction ID</th>
                          </tr>
                        </thead>
                        <tbody className="text-gray-600 fw-semibold fs-7">
                          {selectedPayment.payment_history.map((h) => (
                            <tr key={h.paymenthistory_id}>
                              <td>{h.payment_date}</td>
                              <td>
                                <span className="text-info">
                                  <i className="fa-solid fa-indian-rupee-sign me-1"></i>
                                  {h.payment_amount}
                                </span>
                              </td>
                              <td>
                                <span className="text-warning">
                                  <i className="fa-solid fa-indian-rupee-sign me-1"></i>
                                  {h.balance_amount}
                                </span>
                              </td>
                              <td>{h.paymentmode_name || h.payment_mode}</td>
                              <td>{h.transaction_id || "-"}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <p>No payment history available for this record.</p>
                  )}
                </div>
              </div>
            </Modal>



        </>
    )


}
export default ViewVendors;